import React from 'react';
import { motion, TargetAndTransition } from 'framer-motion';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { theme } from '../../theme';

const animationOne: TargetAndTransition = {
  scaleX: [1, -1],
  x: [-30, 30],
  y: [0, -30],

  transition: {
    x: {
      duration: 0.6,
      repeat: Infinity,
      repeatType: 'reverse'
    },
    y: {
      duration: 0.3,
      ease: 'easeOut',
      repeatType: 'reverse',
      repeat: Infinity
    },
    scaleX: {
      duration: 0.6,
      repeat: Infinity,
      repeatType: 'reverse',
      type: 'tween',
      velocity: 1000,
      ease: 'anticipate'
    }
  }
};

export const LoaderComponent = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ height: '269px' }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: '2rem' }}>
        <motion.svg
          style={{ maxWidth: '2rem' }}
          animate={animationOne}
          fill="#67AEB5"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
        >
          <path d="M19.24 18.94h8.913c0.351-1.149 0.542-2.365 0.542-3.63 0-2.957-1.013-5.655-2.732-7.797-0.538-0.669-1.128-1.278-1.789-1.826-2.050-1.675-4.466-2.72-7.404-2.893-0.019-0.002-0.536-0.003-0.664-0.003-1.342 0-4.421 0.767-4.691 0.862-0.975 0.206-1.939 0.369-2.925 0.369-2.812 0-4.965-1.213-4.965-1.213v12.41c0.036 5.011 3.028 9.506 7.326 11.478 1.599 0.734 3.376 1.144 5.253 1.144 1.898 0 3.694-0.416 5.308-1.165 1.503-0.696 2.838-1.7 3.95-2.896-2.802-0.406-5.119-2.293-6.123-4.841zM22.794 10.28c1.629 0 2.95 1.314 2.95 2.936s-1.32 2.936-2.95 2.936-2.95-1.314-2.95-2.936 1.32-2.936 2.95-2.936z"></path>
        </motion.svg>
      </Box>
      <Typography color={theme.palette.primary.main} textAlign="center">
        {t('infoText.loading')}
      </Typography>
    </Box>
  );
};
